import { getEnvVariable } from '../../../modules/environmentalList';
import ProposedLandUse from './newproposedlanduse';
import ViewProposedLandUse from './vieweditproposedlanduse';
const ProposedLandUseGrid = {
    "title": "Proposed Land Use",
    "type": "grid",
    "key": "ProposedLandUseGrid",
    "gridkey": 'ProposedLandUseGrid',
    "name": "ProposedLandUseGrid",
    "addRoute": true,
    "routeParams": { replace: 'proposedlanduse', param: 'Id', routeName: 'id' },
    "hasreport": true,
    values: {
        addOpen: false,
        editOpen: false,
        editInfo: null,
        allgriddata: null,
        reportOpen: false,
        loadreportfilter: null,
        ReportJsonQueryStr: null,
        load: false,
        navigateItem: null,
        navigation: null,
    },
    sharedValues: ['addOpen', 'editOpen', 'editInfo', 'allgriddata', 'navigateItem', 'navigation', 'loadreportfilter', 'ReportJsonQueryStr', 'reportOpen'],
    aliases: {
        addOpen: 'addOpen',
        editOpen: 'editOpen',
        editInfo: 'editInfo',
        navigateItem: 'navigateItem',
        allgriddata: 'allgriddata',
        navigation: 'navigation',
        reportOpen: 'reportOpen',
        loadreportfilter: 'loadreportfilter',
        ReportJsonQueryStr: 'ReportJsonQueryStr'
    },
    headerProps: {
        title: "Proposed Land Use",
        components: [
            // {
            //     type: 'breadcrumbs',
            //     items: [
            //         {
            //             "link": "Proposed Land Use", "materialicon": "eject", className: 'eps-breadcrumb-item ', class: 'text-light'
            //         }
            //     ],
            // }
        ],

        actions: [

            {
                type: 'fab',
                icon: 'clear',
                name: 'clear',
                color: 'primary',
                title: 'Clear Filters',
                menucolor: '#22a9b3',
                hideon: 'clear',
                hidevalue: false
            },

            {
                type: 'menu',
                icon: 'excel',
                name: 'excel',
                color: 'primary',
                title: 'Export to Excel',
                menucolor: '#c90685',
                hideon: 'excel',
                hidevalue: false,
                items: [{
                    name: 'Export Current Page',
                    action: 'filtercurrent'
                },
                {
                    name: 'Export All Pages',
                    action: 'filterall'
                }
                ]
            },
            // {
            //     type: 'fab',
            //     icon: 'reports',
            //     name: 'reports',
            //     color: 'primary',
            //     title: 'Save Report',
            //     menucolor: '#C85A54',
            //     hideon: 'reports',
            //     hidevalue: false
            // },
            {
                type: 'fab',
                icon: 'add',
                name: 'add',
                color: 'primary',
                hideon: 'addButton',
                hidevalue: true,
                title: 'Add Proposed Land Use',
                menucolor: '#36088a'
            },

        ]
    },
    "columns": [
        {
            "title": "Land Use",
            "field": "LandUseDesc",
            "show": true,
            "width": 180
        },
        {
            "title": "Units",
            "field": "Unit",
            "show": true,
            format: "{0:n2}",
            "width": 120,
            format: "{0:n2}",
            "filter": "numeric"
        },
        {
            "title": "Land Use ADT",
            "field": "LandUseADT",
            "show": getEnvVariable('AccessPortal') == 'E' ? false : true,
            "width": 220,
            format: "{0:n2}",
            "filter": "numeric"
        },
        {
            "title": "Usage Note",
            "field": "UsageNotes",
            "show": true,
            "width": 200
        },
        {
            "title": "Created By",
            "field": "CreatedByName",
            "show": true,
            "width": 185
        },
        {
            "title": "Created On",
            "field": "CreatedOn",
            "show": true,
            "width": 185,
            filter: "date",
            format: "{0:d}",
            convert: "MM/DD/YYYY hh:mm:ss A"
        },
        {
            "title": "Updated By",
            "field": "UpdatedByName",
            "show": true,
            "width": 185
        },
        {
            "title": "Updated On",
            "field": "UpdatedOn",
            "show": true,
            "width": 185,
            filter: "date",
            format: "{0:d}",
            convert: "MM/DD/YYYY hh:mm:ss A"
        },

    ],
    displayName: 'editInfo',
    allgriddata: 'allgriddata',
    navigateItem: 'navigateItem',
    navigation: 'navigation',
    loadreportfilter: 'loadreportfilter',
    ReportJsonQueryStr: 'ReportJsonQueryStr',
    navigateItem: 'navigateItem',
    mapActionsToEffects: {
        load: {
            rules: [{
                run: {
                    valid: [{
                        type: 'grid',
                        "read": [
                            {
                                url: getEnvVariable('Application') + `/api/ProposedLandUse/{routeid1}/Grid?`,
                                "matchProps": [{
                                    name: "routeid1",
                                    key: "routeid1",
                                }],
                                type: 'get',
                                saveAs: {
                                    key: 'data'
                                }
                            }
                        ]
                    },
                    ]
                }
            }]
        },

        addOpen: {
            rules: [{
                check: [
                    {
                        condition: 'AND',
                        rules: [
                            {
                                "name": "addOpen",
                                "type": "!=",
                                "value": true,
                                "rules": []
                            }
                        ]
                    }
                ],
                run: {
                    valid: [{
                        type: 'grid',
                        "read": [
                            {
                                url: getEnvVariable('Application')+`/api/ProposedLandUse/{routeid1}/Grid?`,
                                "matchProps": [{
                                    name: "routeid1",
                                    key: "routeid1",
                                }],
                                type: 'get',
                                saveAs: {
                                    key: 'data'
                                }
                            }
                        ]
                    },
                    ]

                }
            }]
        },
        editOpen: {
            rules: [{
                check: [
                    {
                        condition: 'AND',
                        rules: [
                            {
                                "name": "editOpen",
                                "type": "!=",
                                "value": true,
                                "rules": []
                            }
                        ]
                    }
                ],
                run: {
                    valid: [{
                        type: 'grid',
                        "read": [
                            {
                                url: getEnvVariable('Application') + `/api/ProposedLandUse/{routeid1}/Grid?`,
                                "matchProps": [{
                                    name: "routeid1",
                                    key: "routeid1",
                                }],
                                type: 'get',
                                saveAs: {
                                    key: 'data'
                                }
                            }
                        ]
                    },
                    ]
                }
            }]
        },
        'add': {
            rules: [
                {
                    run: {
                        valid: [
                            {
                                type: 'value',
                                key: 'addOpen',
                                result: true
                            },

                        ]
                    }
                }
            ]
        },
        'display': {
            rules: [
                {
                    run: {
                        valid: [
                            {
                                type: 'value',
                                key: 'editOpen',
                                result: true
                            },
                            {
                                type: 'resultvalue',
                                name: 'editInfo',
                            },
                            {
                                type: 'resultvalue',
                                name: 'allgriddata',
                            },
                            {
                                type: 'resultvalue',
                                name: 'navigateItem',
                            },
                            {
                                type: 'resultvalue',
                                name: 'navigation',
                            },
                        ]
                    }
                }
            ]
        },
        'report': {
            rules: [
                {
                    run: {
                        valid: [
                            {
                                type: 'value',
                                key: 'reportOpen',
                                result: true
                            },
                            {
                                type: 'resultvalue',
                                name: 'loadreportfilter',
                            },
                            {
                                type: 'resultvalue',
                                name: 'ReportJsonQueryStr',
                            },

                        ]
                    }
                }
            ]
        },
    }



}
const ProposedLandUseReport = {
    type: 'popup',
    key: 'ProposedLandUseReport',
    name: 'ProposedLandUseReport',

    anchor: 'right',
    open: false,
    aliases: {
        open: 'reportOpen'
    },
    sharedValues: ['open', 'loadreportfilter', 'ReportJsonQueryStr'],
    container: {
        values: {
            loadreportfilter: null,
            ReportJsonQueryStr: null
        },
        mapValues: {
            Report: [
                {
                    key: 'ReportJsonQueryStr',
                    name: 'ReportJsonQueryStr'
                },
                {
                    key: 'loadreportfilter',
                    name: 'loadreportfilter'
                },
            ],
        },
        mapActionsToEffects: {},
        layout: {
            group: [
                {
                    order: 0,
                    type: 'div',
                    className: '',
                    components: [
                        {
                            name: 'Report'
                        },
                    ]
                }
            ]

        },
        components: {
            Report: {
                "type": "form",
                "key": "Report",
                "name": "Report",
                aliases: {

                },
                sharedValues: ['ReportJsonQueryStr', 'loadreportfilter'],
                values: {
                    loadreportfilter: null,
                    ReportJsonQueryStr: null
                },
                mapActionsToEffects: {},
                layout: {
                    group: [
                        {
                            order: 0,
                            type: 'div',
                            className: '',
                            components: [{
                                name: 'ReportJsonQueryStr',
                                type: 'div',

                            },
                            {
                                name: 'loadreportfilter',
                                type: 'div',

                            }],

                        },
                    ],
                },
                "components": {
                    "ReportJsonQueryStr": {
                        "type": "gridreport",
                        "gridkey": 'ProposedLandUseGrid',
                    },
                },
            }
        }
    }
}

const ProposedLandContainer = {
    type: 'container',
    key: 'proposedlandcontainer',
    values: {
        addOpen: false,
        editOpen: false,
        editInfo: null,
        allgriddata: null,
        navigateItem: null,
        navigation: null,
        loadreportfilter: null,
        ReportJsonQueryStr: null,
        reportOpen: false,
    },
    mapValues: {
        ProposedLandUse: [
            {
                key: 'addOpen',
                name: 'open'
            }
        ],
        ViewProposedLandUse: [
            {
                key: 'editOpen',
                name: 'open'
            },
            {
                key: 'editInfo',
                name: 'editInfo'
            },
            {
                key: 'navigateItem',
                name: 'navigateItem'
            },
            {
                key: 'allgriddata',
                name: 'allgriddata'
            },
            {
                key: 'navigation',
                name: 'navigation'
            },
        ],
        ProposedLandUseGrid: [
            {
                key: 'editOpen',
                name: 'editOpen'
            },
            {
                key: 'addOpen',
                name: 'addOpen'
            },
            {
                key: 'reportOpen',
                name: 'reportOpen'
            },
            {
                key: 'ReportJsonQueryStr',
                name: 'ReportJsonQueryStr'
            },
            {
                key: 'loadreportfilter',
                name: 'loadreportfilter'
            },
        ],
        ProposedLandUseReport: [
            {
                key: 'reportOpen',
                name: 'open'
            },
            {
                key: 'loadreportfilter',
                name: 'loadreportfilter'
            },
            {
                key: 'ReportJsonQueryStr',
                name: 'ReportJsonQueryStr'
            },

        ]
    },
    mapActionsToEffects: {
        'addOpen': {
            rules: [
                {
                    check: [
                        {
                            condition: 'AND',
                            rules: [
                                {
                                    "name": "addOpen",
                                    "type": "!=",
                                    "value": true,
                                    "rules": []
                                }
                            ]
                        }
                    ],
                    uncheck: true,
                    run: {
                        valid: [
                            // {
                            //     type: 'removelayout',
                            //     name: 'ProposedLandUse',
                            // }

                        ],
                        inValid: [
                            {
                                type: 'addlayout',
                                name: 'ProposedLandUse',
                            }
                        ]
                    }
                }
            ]
        },
        'editOpen': {
            rules: [
                {
                    check: [
                        {
                            condition: 'AND',
                            rules: [
                                {
                                    "name": "editOpen",
                                    "type": "!=",
                                    "value": true,
                                    "rules": []
                                }
                            ]
                        }
                    ],
                    uncheck: true,
                    run: {
                        valid: [
                            {
                                type: 'removelayout',
                                name: 'ViewProposedLandUse',
                            }

                        ],
                        inValid: [
                            {
                                type: 'addlayout',
                                name: 'ViewProposedLandUse',
                            }
                        ]
                    }
                }
            ]
        },
        'reportOpen': {
            rules: [
                {
                    check: [
                        {
                            condition: 'AND',
                            rules: [
                                {
                                    "name": "reportOpen",
                                    "type": "!=",
                                    "value": true,
                                    "rules": []
                                }
                            ]
                        }
                    ],
                    uncheck: true,
                    run: {
                        valid: [
                            // {
                            //     type: 'removelayout',
                            //     name: 'ProposedLandUseReport',
                            // }

                        ],
                        inValid: [
                            {
                                type: 'addlayout',
                                name: 'ProposedLandUseReport',
                            }
                        ]
                    }
                }
            ]
        },
    },
    layout: {
        group: [
            {
                order: 0,
                type: 'div',
                className: 'row',
                components: [
                    {
                        name: 'ProposedLandUseGrid'
                    },
                    // {
                    //     name: 'ProposedLandUse'
                    // },
                    // {
                    //     name: 'ViewProposedLandUse'
                    // },
                ]
            }
        ]

    },
    components: {
        ProposedLandUseGrid: ProposedLandUseGrid,
        ProposedLandUse: ProposedLandUse,
        ViewProposedLandUse: ViewProposedLandUse,
        ProposedLandUseReport: ProposedLandUseReport
    }
}


export default ProposedLandContainer
